import { render, staticRenderFns } from "./UserProfileStatsList.vue?vue&type=template&id=3e038bb1&scoped=true"
import script from "./UserProfileStatsList.vue?vue&type=script&lang=js"
export * from "./UserProfileStatsList.vue?vue&type=script&lang=js"
import style0 from "./UserProfileStatsList.vue?vue&type=style&index=0&id=3e038bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e038bb1",
  null
  
)

export default component.exports